import { render, staticRenderFns } from "./ComOne.vue?vue&type=template&id=e21b67d0&scoped=true&"
import script from "./ComOne.vue?vue&type=script&lang=js&"
export * from "./ComOne.vue?vue&type=script&lang=js&"
import style0 from "./ComOne.vue?vue&type=style&index=0&id=e21b67d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21b67d0",
  null
  
)

export default component.exports